<template>
  <div class="right-cart" v-bind:class="{open: isCartOpen}">
    <div class="cart-inner" style="">
      <div id="basket" class="pt-20 pt15 px-10">
        <div class="jagged"></div>
        <div class="cart-contain">
          <div class="flex flex-col" style="max-height: 80%">
            <div class=" close-cart" style=""><a href="javascript: void(0);" @click="showHideCart(false)">{{$t('button_close')}}</a>
            </div>
            <div class="heading-dotted p10 ">
              <span class="lg-cond font-sharp-sans-bold">{{$t('cart.your_basket')}}</span>
            </div>
            <!--<div class="text-center"><span class="t12 ">({{$t('cart.include_tax_message')}})</span></div>-->
            <!--<div class="basket-memo">{{$t('cart.make_change')}}</div>-->
            <div v-if="!byVoucher" class="cart-item-contain pb-10" style="">
              <div class="cart-item t13 67" data-original-title="" title="">
                <p class="pl-10 pt-10 pr-10 typo-l7" v-if="cart.hasOwnProperty('data') && cart.data.length == 0">
                  {{$t('cart.your_basket_empty_1')}}
                </p>
                <!-- ##########################################################-->
                <div class="main-item">
                  <transition-group name="fade1">
                    <div v-for="(data) in cart.data"
                         :key="genUniqueKey(data)"
                         class="flex1 per-item"
                         v-bind:item="data.id">
                      <!-- ################# Show combo item ############# -->
                      <div href="javascript: void(0)" @click.stop="editCombo(data)"
                           v-if="data.product_type == $const.CARD_ITEM_TYPE.COMBO" class="cursor-pointer">
                        <div class="fw600 py-10">
                          <span class="block-left">
                            <span class="menu-price-sub" v-if="data.quantity > 1">{{$t('format_product_not_quantity',{
                                  product_name: data.name || '',
                                  quantity: data.quantity
                                })}}
                            </span>
                            <span class="menu-price-sub" v-else>{{data.name}}</span>
                          </span>
                          <div class="cart-quantity"
                               v-on:click="ModifyQuantity(data, $event)">
                            x {{ data.quantity }}
                          </div>
                          <div class=" block-right block-top">
                            <span>{{$const.CURRENCY}} {{formatNumDisplay(data.sub_total)}}
                              <a @click.prevent.stop="removeCart(data)" href="javascript:void(0)" class="cart-remove">
                                <img src="../../assets/images/icons/remove.svg" alt="remove">
                                <!--<i class="fas fa-trash"></i>-->
                              </a>
                            </span>
                          </div>
                          <div class="clearfix"></div>
                        </div>

                        <div class="" v-for="(item) in data.items" v-bind:key="item.id" v-bind:item="item">
                          <div v-for="(gItem) in item.group_items" v-bind:key="gItem.group_id">
                            <div class="content  cl-78838c">
                              <div class="fw600 basket-item-product">
                                <span class="flex justify-between items-center mr-30">{{(gItem.layer_info ? gItem.layer_info.first ? gItem.layer_info.first.name : '' : '') +' '+ (gItem.name)}}</span>
                              </div>
                            </div>
                            <div class="content cl-78838c" v-if="gItem.layer_info && gItem.layer_info.second">
                              <span class="block-left"><span class="menu-price-sub">{{(gItem.layer_info.second.name ? gItem.layer_info.second.name : '')}}</span></span>
                              <div class="fw600 block-right t13 menu-price-sub"
                                   v-if="gItem.layer_info.second.price > 0">
                                <!--<span>{{$const.CURRENCY}} {{formatNumDisplay(gItem.layer_info.second.price)}}</span>-->
                              </div>
                              <div class="clearfix"></div>
                            </div>
                            <div v-if="gItem.toppings != null">
                              <div v-for="(subitem) in gItem.toppings.extra" :key="genUniqueKey(subitem)"
                                   class="content  cl-78838c" v-if="subitem.special == '1'">
                                <span class="block-left"><span class="menu-price-sub">{{(subitem.name)}}</span></span>
                                <div class="fw600 block-right t13 menu-price-sub" v-if="subitem.price > 0">
                                  <span>{{$const.CURRENCY}} {{formatNumDisplay(subitem.price)}}</span>
                                </div>
                                <div class="clearfix"></div>
                              </div>
                              <div v-for="(subitem) in gItem.toppings.extra" :key="genUniqueKey(subitem)"
                                   class="content  cl-78838c" v-if="subitem.special != '1'">
                                <span class="block-left">
                                  <span class="menu-price-sub" v-if="subitem.quantity <= 1">{{$t('cart.add')+' '+(subitem.name)}}</span>
                                  <span class="menu-price-sub" v-else>{{ $t('format_product', {
                                                  quantity: subitem.quantity,
                                                  product_name: $t('cart.add')+' '+(subitem.name)
                                              })}}</span>

                                </span>
                                <div class="fw600 block-right t13 menu-price-sub" v-if="subitem.price > 0">
                                  <span>{{$const.CURRENCY}} {{formatNumDisplay(subitem.price)}}</span>
                                </div>
                                <div class="clearfix"></div>
                              </div>
                              <div v-for="(subitem) in gItem.toppings.remove" :key="genUniqueKey(subitem)"
                                   class="content  cl-78838c">
                                <span class="block-left"><span class="menu-price-sub">{{$t('cart.remove')+' '+(subitem.name)}}</span></span>
                                <div class="clearfix"></div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                      <!-- ################# Show combo item ############# -->

                      <!-- ################# Show single item ############# -->
                      <div v-if="data.product_type == $const.CARD_ITEM_TYPE.SINGLE" @click.stop="editSingle(data)"
                           class="cursor-pointer">
                        <div class="fw600 py-10">
                          <span class="block-left">
                            <span class="menu-price-sub">
                              {{ formatName(data) }}
                            </span>
                          </span>
                          <div class="cart-quantity"
                               v-on:click="ModifyQuantity(data, $event)">
                            x {{ data.quantity }}
                          </div>
                          <div class=" block-right block-top" style="min-width: 35%">
                            <span class="top-price">
                              {{
                                $t('currency_display', {
                                    currency: $const.CURRENCY,
                                    amount: formatNumDisplay(data.total)
                                })
                              }}
                              <a @click.prevent.stop="removeCart(data)" href="javascript:void(0)" class="cart-remove">
                                <img src="../../assets/images/icons/remove.svg" alt="remove">
                                <!--<i class="fa fa-trash"></i>-->
                              </a>
                            </span>
                          </div>
                        </div>
                        <div class="clearfix"></div>
                        <div class="content  cl-78838c" v-if="data.items.length > 0 && data.items[0].layer_info.second">
                          <span class="block-left"><span class="menu-price-sub">{{(data.items[0].layer_info.second.name ? data.items[0].layer_info.second.name : '')}}</span></span>
                          <div class="fw600 block-right t13 menu-price-sub"
                               v-if="data.items[0].layer_info.second.price > 0">
                              <!--<span>-->
                                <!--{{-->
                                  <!--$t('currency_display', {-->
                                      <!--currency: $const.CURRENCY,-->
                                      <!--amount: formatNumDisplay(data.items[0].layer_info.second.price)-->
                                  <!--})-->
                                <!--}}-->
                              <!--</span>-->
                          </div>
                          <div class="clearfix"></div>
                        </div>
                        <div v-if="data.items[0].toppings != null && data.items[0].toppings.extra">
                          <div v-for="(subitem) in data.items[0].toppings.extra" :key="genUniqueKey(subitem)"
                               class="content  cl-78838c" v-if="subitem.special == '1'">
                            <span class="block-left"><span class="menu-price-sub">{{(subitem.name)}}</span></span>
                            <div class="fw600 block-right t13 menu-price-sub" v-if="subitem.price > 0">
                                <span>
                                  {{
                                    $t('currency_display', {
                                        currency: $const.CURRENCY,
                                        amount: formatNumDisplay(subitem.price)
                                    })
                                  }}
                                </span>
                            </div>
                            <div class="clearfix"></div>
                          </div>

                          <div class="topping-box"
                               v-if="data.items[0].toppings.extra && data.items[0].toppings.extra.length">
                            <div class="heading">{{$t('cart.plasting')}}</div>
                            <div v-for="(subitem) in data.items[0].toppings.extra" :key="genUniqueKey(subitem)"
                                 class="content  cl-78838c" v-if="subitem.special != '1'">
                              <span class="block-left">
                                <span class="menu-price-sub" v-if="subitem.quantity <= 1">{{(subitem.name)}}</span>
                                <span class="menu-price-sub" v-else>{{
                                              $t('format_product', {
                                                  quantity: subitem.quantity,
                                                  product_name: (subitem.name)
                                              })
                                            }}</span>
                              </span>
                              <div class="fw600 block-right t13 menu-price-sub" v-if="subitem.price > 0">
                                          <span>
                                            {{
                                              $t('currency_display', {
                                                  currency: $const.CURRENCY,
                                                  amount: formatNumDisplay(subitem.price)
                                              })
                                            }}
                                          </span>
                              </div>
                              <div class="clearfix"></div>
                            </div>
                          </div>

                          <div class="topping-box"
                               v-if="data.items[0].toppings.remove && data.items[0].toppings.remove.length">
                            <div class="heading">{{$t('cart.minus')}}</div>
                            <div v-for="(subitem) in data.items[0].toppings.remove" :key="genUniqueKey(subitem)"
                                 class="content  cl-78838c">
                              <span class="block-left"><span class="menu-price-sub">{{(subitem.name)}}</span></span>
                              <div class="clearfix"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- ################# Show single item ############# -->

                      <!-- ################# Show half item ############# -->
                      <div v-if="data.product_type == $const.CARD_ITEM_TYPE.HALF" @click.stop="editSingle(data, true)">
                        <div class="fw600 py-10">
                          <span class="block-left">
                            <span class="menu-price-sub" v-if="data.quantity > 1">{{formatName(data)}}</span>
                            <span class="menu-price-sub" v-else>{{(data.name)}}</span>
                          </span>
                          <div class="cart-quantity"
                               v-on:click="ModifyQuantity(data, $event)">
                            x {{ data.quantity }}
                          </div>
                          <div class=" block-right block-top">

                            <span class="top-price">
                              {{
                                $t('currency_display', {
                                    currency: $const.CURRENCY,
                                    amount: formatNumDisplay(data.sub_total)
                                })
                              }}
                              <a @click.prevent.stop="removeCart(data)" href="javascript:void(0)" class="cart-remove">
                                <img src="../../assets/images/icons/remove.svg" alt="remove">
                              </a>
                            </span>
                          </div>
                          <div class="clearfix"></div>
                        </div>

                        <!-- show left -->
                        <div class="" v-if="data.items.length > 0" v-bind:key="data.items[0].id"
                             v-bind:item="data.items[0]">
                          <div class="cart-half content  cl-78838c" v-if="data.items[0].name">
                            <div class="half-item">
                              <span class="fw600 block-left">
                                <span class="menu-left-sub">
  <!--
                                  {{ $t('left_half')+' ('+((data.items.length > 0 && data.items[0].layer_info) ? data.items[0].layer_info.first_name : '')+' '+(data.items[0].name)+')' }}
  -->
                                  {{ $t('left_half') }}
                                </span>
                              </span>
                              <div class=" block-right">
                                <!--<span class="">-->
                                  <!--{{-->
                                    <!--$t('currency_display', {-->
                                        <!--currency: $const.CURRENCY,-->
                                        <!--amount: formatNumDisplay(data.items[0].layer_info.second.price)-->
                                    <!--})-->
                                  <!--}}-->
                                <!--</span>-->
                              </div>
                            </div>

                            <div class="half-sub-item">
                              <div class="content  cl-78838c">
                                <span class="block-left">
                                  <span class="menu-price-sub">
                                  {{ formatName(data.items[0], true) }}
                                  </span>
                                </span>
                                <div class="clearfix"></div>
                              </div>
                            </div>

                            <div class="half-sub-item">
                              <div class="content  cl-78838c">
                                <span class="block-left"><span class="menu-price-sub">{{((data.items.length > 0 && data.items[0].layer_info) ? data.items[0].layer_info.second_name : '')}}</span></span>
                                <div class="clearfix"></div>
                              </div>
                            </div>

                            <div class="half-topping">
                              <div v-if="data.items[0].toppings != null && data.items[0].toppings.extra">
                                <div v-for="(subitem) in data.items[0].toppings.extra" :key="genUniqueKey(subitem)"
                                     class="content  cl-78838c" v-if="subitem.special == '1'">
                                  <span class="block-left"><span class="menu-price-sub">{{(subitem.name)}}</span></span>
                                  <div class=" block-right" v-if="subitem.price > 0"><span class="">+ {{$const.CURRENCY}} {{formatNumDisplay(subitem.price)}} </span>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div v-for="(subitem) in data.items[0].toppings.extra" :key="genUniqueKey(subitem)"
                                     class="content  cl-78838c" v-if="subitem.special != '1'">
                                  <span class="block-left">
                                    <span class="menu-price-sub" v-if="subitem.quantity <= 1">{{(subitem.name)}}</span>
                                    <span class="menu-price-sub" v-else>{{
                                              $t('format_product', {
                                                  quantity: subitem.quantity,
                                                  product_name: (subitem.name)
                                              })
                                            }}</span>
                                  </span>
                                  <div class=" block-right" v-if="subitem.price > 0">
                                    <span class="">
                                        {{
                                          $t('currency_display', {
                                              currency: $const.CURRENCY,
                                              amount: formatNumDisplay(subitem.price)
                                          })
                                        }}
                                    </span>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div v-if="data.items[0].toppings && data.items[0].toppings.remove">
                                  <div v-for="(subitem) in data.items[0].toppings.remove" :key="genUniqueKey(subitem)"
                                       class="content  cl-78838c">
                                    <span class="block-left"><span class="menu-price-sub">{{$t('cart.remove')+' '+(subitem.name)}}</span></span>
                                    <div class="clearfix"></div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                        <!-- show left -->

                        <!-- show right -->
                        <div v-if="data.items.length > 0" v-bind:key="data.items[1].id" v-bind:item="data.items[1]">
                          <div class="cart-half content  cl-78838c" v-if="data.items[1].name">
                            <div class="half-item">
                              <span class="fw600 block-left"><span class="menu-right-sub">
                                <!--{{$t('right_half')+' ('+((data.items.length > 0 && data.items[1].layer_info) ? data.items[1].layer_info.first_name : '')+' '+(data.items[1].name)+')'}}-->
                                {{ $t('right_half') }}
                              </span></span>
                              <div class=" block-right">
                                <!--<span class="">-->
                                  <!--{{-->
                                    <!--$t('currency_display', {-->
                                        <!--currency: $const.CURRENCY,-->
                                        <!--amount: formatNumDisplay(data.items[1].layer_info.second.price)-->
                                    <!--})-->
                                  <!--}}-->
                                <!--</span>-->
                              </div>
                            </div>

                            <div class="half-sub-item">
                              <div class="content  cl-78838c">
                                <span class="block-left">
                                  <span class="menu-price-sub">{{ formatName(data.items[1], true) }}</span>
                                </span>
                                <div class="clearfix"></div>
                              </div>
                            </div>

                            <div class="half-sub-item">
                              <div class="content  cl-78838c">
                                <span class="block-left"><span class="menu-price-sub">{{((data.items.length > 0 && data.items[1].layer_info) ? data.items[1].layer_info.second_name : '')}}</span></span>

                                <div class="clearfix"></div>
                              </div>
                            </div>

                            <div class="half-topping">
                              <div v-if="data.items[1].toppings != null && data.items[1].toppings.extra">
                                <div v-for="(subitem) in data.items[1].toppings.extra" :key="genUniqueKey(subitem)"
                                     class="content  cl-78838c" v-if="subitem.special == '1'">
                                  <span class="block-left">
                                    <span class="menu-price-sub">{{(subitem.name)}}</span>
                                  </span>
                                  <div class=" block-right" v-if="subitem.price > 0">
                                    <span class="">
                                      {{
                                        $t('currency_display', {
                                            currency: $const.CURRENCY,
                                            amount: formatNumDisplay(subitem.price)
                                        })
                                      }}
                                    </span>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div v-for="(subitem) in data.items[1].toppings.extra" :key="genUniqueKey(subitem)"
                                     class="content  cl-78838c" v-if="subitem.special != '1'">
                                  <span class="block-left">
                                    <span class="menu-price-sub" v-if="subitem.quantity <= 1">{{(subitem.name)}}</span>
                                    <span class="menu-price-sub" v-else>{{
                                              $t('format_product', {
                                                  quantity: subitem.quantity,
                                                  product_name: (subitem.name)
                                              })
                                            }}</span>
                                  </span>
                                  <div class=" block-right" v-if="subitem.price > 0">
                                    <span class="">
                                      {{
                                        $t('currency_display', {
                                            currency: $const.CURRENCY,
                                            amount: formatNumDisplay(subitem.price)
                                        })
                                      }}
                                    </span>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>

                                <div v-if="data.items[1].toppings && data.items[1].toppings.remove">
                                  <div v-for="(subitem) in data.items[1].toppings.remove" :key="genUniqueKey(subitem)"
                                       class="content  cl-78838c">
                                    <span class="block-left"><span
                                      class="menu-price-sub">{{(subitem.name)}}</span></span>
                                    <div class="clearfix"></div>
                                  </div>
                                </div>

                              </div>
                            </div>

                          </div>
                        </div>
                        <!-- show right -->
                      </div>
                      <!-- ################# Show half item ############# -->
                    </div>
                  </transition-group>
                </div>

                <div v-if="(cart.data || []).length > 0 && cart.is_show_cutlery && cutlery" class="mt-10">
                  <label class="d-flex align-items-center" style="width: 100%" for="extraCutlery">
                    <img :src="getValueFromAttr(cutlery, 'image.desktop_thumbnail')" alt="icon-cutlery" style="height: 24px">
                    <span style="margin-right: 5px; margin-left: 5px;">{{cutlery.name || ''}}</span>
                    <div class="ml-auto">
                      <input class="checkbox" type="checkbox" id="extraCutlery" name="extra_condiment" :true-value="1" :false-value="0" v-model="cart.is_use_cutlery" v-on:change="updateCartData" />
                      <i class="icon-checkbox-cart"></i>
                    </div>
                  </label>
                  <p class="text-gray">{{ cart.is_use_cutlery ? getTextInErrorMessage('CHECK-CUTLERY-DESCRIPTION') : getTextInErrorMessage('UNCHECK-CUTLERY-DESCRIPTION') }}</p>
                </div>

                <!-- ########################### DELIVERY FEE ###############################-->
                <div class="per-itemp item-coupon no-remove l-10 pt-10 t14 fw600" v-if="$const.FLAG_DELIVERY_FEE && cart.delivery_fee && cart.delivery_fee > 0">
                  <div class="xs-flex xs-justify-between pr-10 mb-10" style="width: 100%">
                    <div class="">
                      {{$t('cart.delivery_fee')}}
                    </div>
                    <div class="">
                        <span class="t16">{{$const.CURRENCY}}
                          <span class="t16 ">{{ formatNumDisplay(cart.delivery_fee) }}</span>
                        </span>
                    </div>
                  </div>
                </div>
                <!-- ##################### COUPON #####################################-->
                <template v-if="cart.coupon && cart.coupon.data">
                  <div v-for="coupon in cart.coupon.data" :key="genUniqueKey(coupon)">
                    <div v-if="(!lodash.includes($const.COUPON_TYPES.CIRCLE_DISCOUNT, coupon.discount_type)) && coupon.discount_type != $const.COUPON_TYPE_FREE_DELIVERY"
                      class="xs-flex xs-justify-between xs-full-width mt-5 mb-15">
                      <div v-if="coupon.discount_type != $const.COUPON_TYPE_FREE_DELIVERY">
                        <span class="fw-normal">{{ $t('cart.discount') + ": " }}</span>
                        <span class="code t16 cart-coupon-code-text fw600">{{coupon.code}}</span>
                      </div>
                      <div class="action-quanlity-remove xs-flex">
                        <div v-if="coupon.discount_quantity && coupon.discount_quantity > 0 && coupon.discount_type != $const.COUPON_TYPE_FREE_DELIVERY"
                          class="cart-quantity">
                          x {{coupon.discount_quantity}}
                        </div>
                        <a @click="removeCoupon(coupon.code)" href="javascript:void(0)" class="pl-5 cart-remove"
                          v-if="!coupon.is_auto && coupon.discount_type != $const.COUPON_TYPE_FREE_DELIVERY">
                          <img src="../../assets/images/icons/remove.svg" alt="remove">
                        </a>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- ############################ RM VOUCHER ##############################-->
                <div
                  class="per-item item-rm-voucher no-remove l-10 pt-10 pb-10 mb-10 t14 fw600"
                  :class="(cart.delivery_fee > 0 || (cart.coupon && cart.coupon.data.length > 1)) && 'item-rm-voucher-border-top'"
                  v-if="cart.revenue_monster_vouchers && cart.revenue_monster_vouchers.vouchers_success && cart.revenue_monster_vouchers.vouchers_success.length > 0">
                  <span class="fw-normal">{{(cart.revenue_monster_vouchers.vouchers_success.length > 1 ? $t('vouchers_title') : $t('voucher')) + ": " }}</span>
                  <div v-for="voucher in cart.revenue_monster_vouchers.vouchers_success" :key="genUniqueKey(voucher.code)"
                    class="xs-full-width per-rm-voucher xs-flex xs-justify-between">
                    <span class="code t14 fw700">{{voucher.name}} ({{$const.CURRENCY}} {{formatNumDisplay(voucher.discount_value)}})</span>
                    <div class="action-quanlity-remove xs-flex">
                      <div
                        class="cart-quantity">
                        x 1
                      </div>
                      <a @click="removeCoupon(voucher.code, true)" href="javascript:void(0)" class="pl-5 cart-remove">
                        <img src="../../assets/images/icons/remove.svg" alt="remove">
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Sub total -->
              <div class="p-8 t14 fw700 opacity-75 color-333" v-if="cart.sub_total_without_tax">
                  <div class="display-flex" style="width: 100%">
                      <div class="block-left flex1 display-flex flex-row">{{$t('cart.subtotal')}}</div>
                      <div class="block-right ">
                      <span class="t16">{{$const.CURRENCY}}
                        <span class="t16 " id="sub_total_price">
                          {{ formatNumDisplay(cart.sub_total_without_tax) }}
                        </span>
                      </span>
                      </div>
                  </div>
              </div>
              <!-- Discount -->
              <div class="p-8 t14 fw700 opacity-75 color-333" v-if="cart.total_discount">
                <div class="display-flex" style="width: 100%">
                  <div class="block-left flex1 display-flex flex-row">{{$t('cart.total_discount')}}</div>
                  <div class="block-right ">
                      <span class="t16">{{$const.CURRENCY}}
                        <span class="t16 " id="total_discount">
                          {{ (cart.total_discount > 0 ? '-' : '') + formatNumDisplay(cart.total_discount) }}
                        </span>
                      </span>
                  </div>
                </div>
              </div>
              <!-- Service Tax @ 6% -->
              <div class="p-8 t14 fw700 opacity-75 color-333" v-if="isShowInCart && formatPercent(cart.tax_percent) > 0">
                <div class="display-flex">
                  <div class="block-left flex1 display-flex flex-row">{{$t('cart.service_tax')}}</div>
                  <span class="t16">
                  {{
                    $t('currency_display', {
                        currency: $const.CURRENCY,
                        amount: formatNumDisplay(cart.tax_total)
                    })
                  }}
                </span>
                </div>
              </div>
              <!-- Total before rounding -->
              <div class="p-8 t14 fw700 opacity-75 color-333" v-if="isShowInCart && formatPercent(cart.tax_percent) > 0">
                <div class="display-flex">
                  <div class="block-left flex1 display-flex flex-row">{{$t('total_before_rounding')}}</div>
                  <span class="t16">
                  {{
                    $t('currency_display', {
                        currency: $const.CURRENCY,
                        amount: formatNumDisplay(cart.total)
                    })
                  }}
                </span>
                </div>
              </div>
              <!-- Rounding adjustment -->
              <div class="p-8 t12 fw-700 opacity-75 color-333" v-if="isShowInCart">
                <div class="display-flex">
                  <div class="flex1">{{$t('cart.rounding_adjustment')}}</div>
                  <span class="t14">
                  {{
                    $t('currency_display', {
                        currency: $const.CURRENCY,
                        amount: formatNumDisplay(cart.rounding_adjustment|| 0),
                        plus: (cart.rounding_adjustment|| 0) > 0 ? '+' : '',
                    })
                  }}
                </span>
                </div>
              </div>
              <!-- Grand Total -->
              <div class="p-8 t14 fw700 opacity-75 color-333" v-if="isShowInCart">
                <div class="display-flex">
                  <div class="flex1">{{$t('cart.grand_total')}}</div>
                  <span class="t18">
                  {{
                    $t('currency_display', {
                        currency: $const.CURRENCY,
                        amount: formatNumDisplay(cart.grant_total|| 0)
                    })
                  }}
                </span>
                </div>
              </div>
              <!-- Voucher -->
              <div class="p-8 t14 fw700 opacity-75 color-333" v-if="cart.revenue_monster_vouchers && cart.revenue_monster_vouchers.total_discount > 0">
                <div class="display-flex">
                  <div class="block-left flex1 display-flex flex-row">{{$t('voucher')}}</div>
                  <span class="t16" v-if="cart.revenue_monster_vouchers && cart.revenue_monster_vouchers.total_discount">
                  {{
                    $t('currency_display', {
                        currency: $const.CURRENCY,
                        amount: formatNumDisplay(getRedeemedRMVoucher(cart.revenue_monster_vouchers.total_discount)),
                        plus: getRedeemedRMVoucher(cart.revenue_monster_vouchers.total_discount) > 0 ? '-' : '',
                    })
                  }}
                </span>
                </div>
              </div>
              <!-- Your total -->
              <div class="p-8 pb-15 t17 fw-700" v-if="isShowInCart">
                <div class="display-flex">
                  <div class="flex1">{{$t('cart.total')}}</div>
                  <span class="t18">
                  {{
                    $t('currency_display', {
                        currency: $const.CURRENCY,
                        amount: formatNumDisplay(cart.grand_total_after_apply_rm)
                    })
                  }}
                </span>
                </div>
              </div>
                <div v-if="!byVoucher" class="padding-left-right-5">
                    <div class="hut-rewards-cart" v-if="$auth.check() ">
                        <div>
                            <div style="max-width: 200px;margin: 0 auto; padding-bottom: 30px">
                                <img src="https://static.phdvasia.com/my/fcds/hutawards/hut-reward-black.png">
                            </div>
                            <div class="hut_reward" style="font-size: 14px">
                                <div style="width: 100%">
                                    <div class="xs-flex xs-justify-between flex-wrap xs-mb-5">
                                        <span class="xs-mb-0">{{$t('available')}}</span>
                                        <span class="xs-mb-0">
                          {{cart.customer_point != undefined ? cart.customer_point : ($auth.user().point ? $auth.user().point : 0)}} <span><img
                                                style="max-width: 20px"
                                                src="https://static.phdvasia.com/my/fcds/hutawards/pizza-icon.png"></span> slices
                        </span>
                                    </div>
                                    <div class="xs-flex xs-justify-between flex-wrap xs-mb-5">
                                        <span class="xs-mb-0">{{$t('earned')}}</span>
                                        <span class="xs-mb-0">
                          {{cart.hut_reward_point ? cart.hut_reward_point : 0}} <span><img style="max-width: 20px"
                                                                                           src="https://static.phdvasia.com/my/fcds/hutawards/pizza-icon.png"></span> slices
                        </span>
                                    </div>
                                    <div class="xs-flex xs-justify-between flex-wrap xs-mb-5"
                                         v-if="cart.hut_reward_used > 0">
                                        <span class="xs-mb-0">{{$t('used')}}</span>
                                        <span style="float: right">
                          {{cart.hut_reward_used ? cart.hut_reward_used : 0}} <span><img style="max-width: 20px"
                                                                                         src="https://static.phdvasia.com/my/fcds/hutawards/pizza-icon.png"></span> slices
                        </span>
                                    </div>
                                    <div class="xs-flex xs-justify-between flex-wrap xs-mb-5 pt-5 hut-rewards-balance">
                                        <span class="xs-mb-0">{{$t('new_balance')}}</span>
                                        <span class="xs-mb-0">
                          {{
                             (cart.customer_point != undefined ? cart.customer_point : ($auth.user().point ? $auth.user().point : 0))
                          + (cart.hut_reward_point ? cart.hut_reward_point : 0)
                          - (cart.hut_reward_used ? cart.hut_reward_used : 0)
                          }} <span><img style="max-width: 20px"
                                        src="https://static.phdvasia.com/my/fcds/hutawards/pizza-icon.png"></span> slices
                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="padding-left-right-5 mt-10">
                            <div class="hut-reward-text" @click="showModalHutReward">{{$t('get_free_food')}}</div>
                        </div>
                    </div>
                </div>

              <div v-if="!byVoucher" class="padding-left-right-5 mt-10">
                <div class="coupon-code-text cl-78838c" @click="$router.push($const.CATEGORY_COUPON_URI)">{{$t('cart.got_voucher_code')}}</div>
              </div>

               <div class="padding-left-right-5">
                   <div class="donation-box" v-if="donation != null ">
                       <label class="display-flex" style="width: 100%"
                              for="isDonation">
                           <div class="mt-20">
                               <input class="xs-block xs-p-5 checkbox " id="isDonation"
                                      name="is_donation" :true-value="1" :false-value="0"
                                      v-model="cart.is_use_donation" v-on:change="updateDonationCartData"
                                      type="checkbox">
                               <span class="icon-checkbox-cart"></span>
                           </div>
                           <div>
                               <img style="width: 200px; margin-top: 10px;" :src="donation.imagelink">
                           </div>
                           <div class="typo-l8 pl15" style="line-height: 15px; margin-top: 15px;">{{ donation.description }}</div>
                       </label>
                   </div>
               </div>
            </div>
            <div v-else class="cart-item-contain pb-10">
              <div class="cart-item t13 67" data-original-title="" title="">
                <p class="pl-10 pt-10 pr-10 typo-l7" v-if="cart.hasOwnProperty('data') && cart.data.length == 0">
                  {{$t('cart.your_basket_empty_1')}}
                </p>
                <!-- ##########################################################-->
                <div class="main-item">
                  <transition-group name="fade1">
                    <div v-for="(data) in cart.data"
                         :key="genUniqueKey(data)"
                         class="flex1 per-item"
                         v-bind:item="data.id">
                      <!-- ################# Show combo item ############# -->
                      <div href="javascript: void(0)" @click.stop="editCombo(data)"
                           v-if="data.product_type == $const.CARD_ITEM_TYPE.COMBO" class="cursor-pointer">
                        <div class="fw600 py-10">
                          <span class="block-left">
                            <span class="menu-price-sub" v-if="data.quantity > 1">{{$t('format_product_not_quantity',{
                                  product_name: data.name || '',
                                  quantity: data.quantity
                                })}}
                            </span>
                            <span class="menu-price-sub" v-else>{{data.name}}</span>
                          </span>
                          <div class="cart-quantity"
                               v-on:click="ModifyQuantity(data, $event)">
                            x {{ data.quantity }}
                          </div>
                          <div class=" block-right block-top">
                            <span>{{$const.CURRENCY}} {{formatNumDisplay(data.sub_total)}}
                              <a @click.prevent.stop="removeCart(data)" href="javascript:void(0)" class="cart-remove">
                                <img src="../../assets/images/icons/remove.svg" alt="remove">
                                <!--<i class="fas fa-trash"></i>-->
                              </a>
                            </span>
                          </div>
                          <div class="clearfix"></div>
                        </div>

                        <div class="" v-for="(item) in data.items" v-bind:key="item.id" v-bind:item="item">
                          <div v-for="(gItem) in item.group_items" v-bind:key="gItem.group_id">
                            <div class="content  cl-78838c">
                              <div class="fw600 basket-item-product">
                                <span class="flex justify-between items-center mr-30">{{(gItem.layer_info ? gItem.layer_info.first ? gItem.layer_info.first.name : '' : '') +' '+ (gItem.name)}}</span>
                              </div>
                            </div>
                            <div class="content cl-78838c" v-if="gItem.layer_info && gItem.layer_info.second">
                              <span class="block-left"><span class="menu-price-sub">{{(gItem.layer_info.second.name ? gItem.layer_info.second.name : '')}}</span></span>
                              <div class="fw600 block-right t13 menu-price-sub"
                                   v-if="gItem.layer_info.second.price > 0">
                                <!--<span>{{$const.CURRENCY}} {{formatNumDisplay(gItem.layer_info.second.price)}}</span>-->
                              </div>
                              <div class="clearfix"></div>
                            </div>
                            <div v-if="gItem.toppings != null">
                              <div v-for="(subitem) in gItem.toppings.extra" :key="genUniqueKey(subitem)"
                                   class="content  cl-78838c" v-if="subitem.special == '1'">
                                <span class="block-left"><span class="menu-price-sub">{{(subitem.name)}}</span></span>
                                <div class="fw600 block-right t13 menu-price-sub" v-if="subitem.price > 0">
                                  <span>{{$const.CURRENCY}} {{formatNumDisplay(subitem.price)}}</span>
                                </div>
                                <div class="clearfix"></div>
                              </div>
                              <div v-for="(subitem) in gItem.toppings.extra" :key="genUniqueKey(subitem)"
                                   class="content  cl-78838c" v-if="subitem.special != '1'">
                                <span class="block-left">
                                  <span class="menu-price-sub" v-if="subitem.quantity <= 1">{{$t('cart.add')+' '+(subitem.name)}}</span>
                                  <span class="menu-price-sub" v-else>{{ $t('format_product', {
                                                  quantity: subitem.quantity,
                                                  product_name: $t('cart.add')+' '+(subitem.name)
                                              })}}</span>

                                </span>
                                <div class="fw600 block-right t13 menu-price-sub" v-if="subitem.price > 0">
                                  <span>{{$const.CURRENCY}} {{formatNumDisplay(subitem.price)}}</span>
                                </div>
                                <div class="clearfix"></div>
                              </div>
                              <div v-for="(subitem) in gItem.toppings.remove" :key="genUniqueKey(subitem)"
                                   class="content  cl-78838c">
                                <span class="block-left"><span class="menu-price-sub">{{$t('cart.remove')+' '+(subitem.name)}}</span></span>
                                <div class="clearfix"></div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                      <!-- ################# Show combo item ############# -->

                      <!-- ################# Show single item ############# -->
                      <div v-if="data.product_type == $const.CARD_ITEM_TYPE.SINGLE" @click.stop="editSingle(data)"
                           class="cursor-pointer">
                        <div class="fw600 py-10">
                          <span class="block-left">
                            <span class="menu-price-sub">
                              {{ formatName(data) }}
                            </span>
                          </span>
                          <div class="cart-quantity"
                               v-on:click="ModifyQuantity(data, $event)">
                            x {{ data.quantity }}
                          </div>
                          <div class=" block-right block-top" style="min-width: 35%">
                            <span class="top-price">
                              {{
                                $t('currency_display', {
                                    currency: $const.CURRENCY,
                                    amount: formatNumDisplay(data.total)
                                })
                              }}
                              <a @click.prevent.stop="removeCart(data)" href="javascript:void(0)" class="cart-remove">
                                <img src="../../assets/images/icons/remove.svg" alt="remove">
                                <!--<i class="fa fa-trash"></i>-->
                              </a>
                            </span>
                          </div>
                        </div>
                        <div class="clearfix"></div>
                        <div class="content  cl-78838c" v-if="data.items.length > 0 && data.items[0].layer_info.second">
                          <span class="block-left"><span class="menu-price-sub">{{(data.items[0].layer_info.second.name ? data.items[0].layer_info.second.name : '')}}</span></span>
                          <div class="fw600 block-right t13 menu-price-sub"
                               v-if="data.items[0].layer_info.second.price > 0">
                              <!--<span>-->
                                <!--{{-->
                                  <!--$t('currency_display', {-->
                                      <!--currency: $const.CURRENCY,-->
                                      <!--amount: formatNumDisplay(data.items[0].layer_info.second.price)-->
                                  <!--})-->
                                <!--}}-->
                              <!--</span>-->
                          </div>
                          <div class="clearfix"></div>
                        </div>
                        <div v-if="data.items[0].toppings != null && data.items[0].toppings.extra">
                          <div v-for="(subitem) in data.items[0].toppings.extra" :key="genUniqueKey(subitem)"
                               class="content  cl-78838c" v-if="subitem.special == '1'">
                            <span class="block-left"><span class="menu-price-sub">{{(subitem.name)}}</span></span>
                            <div class="fw600 block-right t13 menu-price-sub" v-if="subitem.price > 0">
                                <span>
                                  {{
                                    $t('currency_display', {
                                        currency: $const.CURRENCY,
                                        amount: formatNumDisplay(subitem.price)
                                    })
                                  }}
                                </span>
                            </div>
                            <div class="clearfix"></div>
                          </div>

                          <div class="topping-box"
                               v-if="data.items[0].toppings.extra && data.items[0].toppings.extra.length">
                            <div class="heading">{{$t('cart.plasting')}}</div>
                            <div v-for="(subitem) in data.items[0].toppings.extra" :key="genUniqueKey(subitem)"
                                 class="content  cl-78838c" v-if="subitem.special != '1'">
                              <span class="block-left">
                                <span class="menu-price-sub" v-if="subitem.quantity <= 1">{{(subitem.name)}}</span>
                                <span class="menu-price-sub" v-else>{{
                                              $t('format_product', {
                                                  quantity: subitem.quantity,
                                                  product_name: (subitem.name)
                                              })
                                            }}</span>
                              </span>
                              <div class="fw600 block-right t13 menu-price-sub" v-if="subitem.price > 0">
                                          <span>
                                            {{
                                              $t('currency_display', {
                                                  currency: $const.CURRENCY,
                                                  amount: formatNumDisplay(subitem.price)
                                              })
                                            }}
                                          </span>
                              </div>
                              <div class="clearfix"></div>
                            </div>
                          </div>

                          <div class="topping-box"
                               v-if="data.items[0].toppings.remove && data.items[0].toppings.remove.length">
                            <div class="heading">{{$t('cart.minus')}}</div>
                            <div v-for="(subitem) in data.items[0].toppings.remove" :key="genUniqueKey(subitem)"
                                 class="content  cl-78838c">
                              <span class="block-left"><span class="menu-price-sub">{{(subitem.name)}}</span></span>
                              <div class="clearfix"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- ################# Show single item ############# -->

                      <!-- ################# Show half item ############# -->
                      <div v-if="data.product_type == $const.CARD_ITEM_TYPE.HALF" @click.stop="editSingle(data, true)">
                        <div class="fw600 py-10">
                          <span class="block-left">
                            <span class="menu-price-sub" v-if="data.quantity > 1">{{formatName(data)}}</span>
                            <span class="menu-price-sub" v-else>{{(data.name)}}</span>
                          </span>
                          <div class="cart-quantity"
                               v-on:click="ModifyQuantity(data, $event)">
                            x {{ data.quantity }}
                          </div>
                          <div class=" block-right block-top">

                            <span class="top-price">
                              {{
                                $t('currency_display', {
                                    currency: $const.CURRENCY,
                                    amount: formatNumDisplay(data.sub_total)
                                })
                              }}
                              <a @click.prevent.stop="removeCart(data)" href="javascript:void(0)" class="cart-remove">
                                <img src="../../assets/images/icons/remove.svg" alt="remove">
                              </a>
                            </span>
                          </div>
                          <div class="clearfix"></div>
                        </div>

                        <!-- show left -->
                        <div class="" v-if="data.items.length > 0" v-bind:key="data.items[0].id"
                             v-bind:item="data.items[0]">
                          <div class="cart-half content  cl-78838c" v-if="data.items[0].name">
                            <div class="half-item">
                              <span class="fw600 block-left">
                                <span class="menu-left-sub">
  <!--
                                  {{ $t('left_half')+' ('+((data.items.length > 0 && data.items[0].layer_info) ? data.items[0].layer_info.first_name : '')+' '+(data.items[0].name)+')' }}
  -->
                                  {{ $t('left_half') }}
                                </span>
                              </span>
                              <div class=" block-right">
                                <!--<span class="">-->
                                  <!--{{-->
                                    <!--$t('currency_display', {-->
                                        <!--currency: $const.CURRENCY,-->
                                        <!--amount: formatNumDisplay(data.items[0].layer_info.second.price)-->
                                    <!--})-->
                                  <!--}}-->
                                <!--</span>-->
                              </div>
                            </div>

                            <div class="half-sub-item">
                              <div class="content  cl-78838c">
                                <span class="block-left">
                                  <span class="menu-price-sub">
                                  {{ formatName(data.items[0], true) }}
                                  </span>
                                </span>
                                <div class="clearfix"></div>
                              </div>
                            </div>

                            <div class="half-sub-item">
                              <div class="content  cl-78838c">
                                <span class="block-left"><span class="menu-price-sub">{{((data.items.length > 0 && data.items[0].layer_info) ? data.items[0].layer_info.second_name : '')}}</span></span>
                                <div class="clearfix"></div>
                              </div>
                            </div>

                            <div class="half-topping">
                              <div v-if="data.items[0].toppings != null && data.items[0].toppings.extra">
                                <div v-for="(subitem) in data.items[0].toppings.extra" :key="genUniqueKey(subitem)"
                                     class="content  cl-78838c" v-if="subitem.special == '1'">
                                  <span class="block-left"><span class="menu-price-sub">{{(subitem.name)}}</span></span>
                                  <div class=" block-right" v-if="subitem.price > 0"><span class="">+ {{$const.CURRENCY}} {{formatNumDisplay(subitem.price)}} </span>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div v-for="(subitem) in data.items[0].toppings.extra" :key="genUniqueKey(subitem)"
                                     class="content  cl-78838c" v-if="subitem.special != '1'">
                                  <span class="block-left">
                                    <span class="menu-price-sub" v-if="subitem.quantity <= 1">{{(subitem.name)}}</span>
                                    <span class="menu-price-sub" v-else>{{
                                              $t('format_product', {
                                                  quantity: subitem.quantity,
                                                  product_name: (subitem.name)
                                              })
                                            }}</span>
                                  </span>
                                  <div class=" block-right" v-if="subitem.price > 0">
                                    <span class="">
                                        {{
                                          $t('currency_display', {
                                              currency: $const.CURRENCY,
                                              amount: formatNumDisplay(subitem.price)
                                          })
                                        }}
                                    </span>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div v-if="data.items[0].toppings && data.items[0].toppings.remove">
                                  <div v-for="(subitem) in data.items[0].toppings.remove" :key="genUniqueKey(subitem)"
                                       class="content  cl-78838c">
                                    <span class="block-left"><span class="menu-price-sub">{{$t('cart.remove')+' '+(subitem.name)}}</span></span>
                                    <div class="clearfix"></div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                        <!-- show left -->

                        <!-- show right -->
                        <div v-if="data.items.length > 0" v-bind:key="data.items[1].id" v-bind:item="data.items[1]">
                          <div class="cart-half content  cl-78838c" v-if="data.items[1].name">
                            <div class="half-item">
                              <span class="fw600 block-left"><span class="menu-right-sub">
                                <!--{{$t('right_half')+' ('+((data.items.length > 0 && data.items[1].layer_info) ? data.items[1].layer_info.first_name : '')+' '+(data.items[1].name)+')'}}-->
                                {{ $t('right_half') }}
                              </span></span>
                              <div class=" block-right">
                                <!--<span class="">-->
                                  <!--{{-->
                                    <!--$t('currency_display', {-->
                                        <!--currency: $const.CURRENCY,-->
                                        <!--amount: formatNumDisplay(data.items[1].layer_info.second.price)-->
                                    <!--})-->
                                  <!--}}-->
                                <!--</span>-->
                              </div>
                            </div>

                            <div class="half-sub-item">
                              <div class="content  cl-78838c">
                                <span class="block-left">
                                  <span class="menu-price-sub">{{ formatName(data.items[1], true) }}</span>
                                </span>
                                <div class="clearfix"></div>
                              </div>
                            </div>

                            <div class="half-sub-item">
                              <div class="content  cl-78838c">
                                <span class="block-left"><span class="menu-price-sub">{{((data.items.length > 0 && data.items[1].layer_info) ? data.items[1].layer_info.second_name : '')}}</span></span>

                                <div class="clearfix"></div>
                              </div>
                            </div>

                            <div class="half-topping">
                              <div v-if="data.items[1].toppings != null && data.items[1].toppings.extra">
                                <div v-for="(subitem) in data.items[1].toppings.extra" :key="genUniqueKey(subitem)"
                                     class="content  cl-78838c" v-if="subitem.special == '1'">
                                  <span class="block-left">
                                    <span class="menu-price-sub">{{(subitem.name)}}</span>
                                  </span>
                                  <div class=" block-right" v-if="subitem.price > 0">
                                    <span class="">
                                      {{
                                        $t('currency_display', {
                                            currency: $const.CURRENCY,
                                            amount: formatNumDisplay(subitem.price)
                                        })
                                      }}
                                    </span>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div v-for="(subitem) in data.items[1].toppings.extra" :key="genUniqueKey(subitem)"
                                     class="content  cl-78838c" v-if="subitem.special != '1'">
                                  <span class="block-left">
                                    <span class="menu-price-sub" v-if="subitem.quantity <= 1">{{(subitem.name)}}</span>
                                    <span class="menu-price-sub" v-else>{{
                                              $t('format_product', {
                                                  quantity: subitem.quantity,
                                                  product_name: (subitem.name)
                                              })
                                            }}</span>
                                  </span>
                                  <div class=" block-right" v-if="subitem.price > 0">
                                    <span class="">
                                      {{
                                        $t('currency_display', {
                                            currency: $const.CURRENCY,
                                            amount: formatNumDisplay(subitem.price)
                                        })
                                      }}
                                    </span>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>

                                <div v-if="data.items[1].toppings && data.items[1].toppings.remove">
                                  <div v-for="(subitem) in data.items[1].toppings.remove" :key="genUniqueKey(subitem)"
                                       class="content  cl-78838c">
                                    <span class="block-left"><span
                                      class="menu-price-sub">{{(subitem.name)}}</span></span>
                                    <div class="clearfix"></div>
                                  </div>
                                </div>

                              </div>
                            </div>

                          </div>
                        </div>
                        <!-- show right -->
                      </div>
                      <!-- ################# Show half item ############# -->
                    </div>
                  </transition-group>
                </div>


                <!-- ##########################################################-->
                <div class="per-itemp item-coupon no-remove l-10 pt-10 pr-10 t14 fw600" v-if="$const.FLAG_DELIVERY_FEE && cart.delivery_fee && cart.delivery_fee > 0">
                  <div class="display-flex" style="width: 100%">
                    <div class="block-left flex1 display-flex flex-row">
                      {{$t('cart.delivery_fee')}}
                    </div>
                    <div class="block-right ">
                        <span class="t16">{{$const.CURRENCY}}
                          <span class="t16 ">{{ formatNumDisplay(cart.delivery_fee) }}</span>
                        </span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div v-if="byVoucher" class="subtotal-voucher">
            <div class="pl-10 pt-10 pr-10 pl-10 pt-10 pr-10 t14 fw600 color-333" v-if="cart.sub_total_without_tax">
              <div class="display-flex" style="width: 100%">
                  <div class="block-left flex1 display-flex flex-row">{{$t('cart.subtotal')}}</div>
                  <div class="block-right ">
                  <span class="t16">{{$const.CURRENCY}}
                    <span class="t16 " id="sub_total_price">
                      {{ formatNumDisplay(cart.sub_total_without_tax) }}
                    </span>
                  </span>
                  </div>
                </div>
            </div>
          </div>



            <!-- ADD-ON -->
            <div class="addons-cart show-addons" v-if="true && !byVoucher"
                 :class="{'has-min-cart-alert': !checkMinCart()}">
              <div class="hungry-title container-shake-animation">
                {{$t("hungry_more")}}
              </div>
              <!--##############################-Silder-####################### -->
                <div class="carousel-inner carousel slide " v-if="slides.length > 0 "
                     style="    background: rgb(245, 247, 249); height: 82px">

                <vueper-slides :autoplay="true" ref="myCarousel" :touchable="is_mobile ? true : false" :bullets="false" :pauseOnHover="true">
                  <vueper-slide v-for="slide in slides" :key="slide.id">
                    <div slot="slideContent">
                      <div class="item item-addon">

                        <!--ITEM'S IMAGE-->
                        <figure class="image item-addon__img">
                          <img style="" v-bind:src="slide.imagelink">
                        </figure>

                        <!--ITEM'S NAME-->
                        <div class="name item-addon__info">
                          <h5 class="item-addon__txt" style="margin-bottom: 10px">{{slide.name}}</h5>
                        </div>
                        <!--./ITEM'S NAME-->

                          <div class="price" style="margin-bottom: 10px;">
                              <div class="text-contain">
                                  <div class="text-item">
                                      <div class=" phPrice t15 fw600 text-black" style="">
                                          <p><span>{{$const.CURRENCY}}</span>{{slide.baseprice}}</p>
                                      </div>
                                      <div class="virtual-price t13 fw600 cl-78838c " style="">
                                          <strike><span>{{$const.CURRENCY}}</span>{{slide.promotionprice}}</strike></div>
                                  </div>
                              </div>
                          </div>

                        <!--Add-to-cart button-->
                        <div class="button item-addon__btn">
                          <button class="btn btn--primary btn--sm btn-add-single-item-addon t13" @click="AddAddOnToCart(slide)"
                                  style="padding: 8px 7px">{{$t('button_add_now')}}
                          </button>
                        </div>
                        <!--./Add-to-cart button-->
                      </div>
                    </div>
                  </vueper-slide>
                </vueper-slides>
              </div>
              <!--##############################-Silder-####################### -->
              <a @click="$refs.myCarousel.previous()" class="left carousel-control" href="#" data-slide="prev"
                 style="width: 25px;">
                <span class="glyphicon glyphicon-chevron-left"></span>
                <span class="sr-only">{{$t('button_previous')}}</span>
              </a>
              <a @click="$refs.myCarousel.next()" class="right carousel-control" href="#" data-slide="next"
                 style="width: 25px;">
                <span class="glyphicon glyphicon-chevron-right"></span>
                <span class="sr-only">{{$t('button_next')}}</span>
              </a>
            </div>
            <!-- ./ADD-ON -->

          </div>
        </div>
      </div>

      <div class="footer-checkout checkout-out  margin-bottom">
        <div style="width: 100%; margin: auto">
          <button class="btn btn-success show-basket " v-if="(is_mobile && (!isCartOpen || cart.grand_total_after_apply_rm < 0))"
                  @click="showHideCart(true)">
            <div class="float-l min-cart" v-if="cart.data != null && getTotalItem() > 0">
              <span class="num">{{cart.data ? getTotalItem() : 0}}</span>
            </div>
            {{$t('button_view_basket')}}
            <span class="float-r" v-if="cart.grand_total_after_apply_rm > 0">{{$const.CURRENCY}}{{formatNumDisplay(cart.grand_total_after_apply_rm)}}</span>
          </button>
          <div v-else class="display-flex group-button-cart-checkout flex-column">
            <button class="btn btn-success btn-checkout-cart item-btn " @click="checkout" style="" v-if="checkMinCart()" :disabled="isLoading">
              <div v-if="isLoading" class="float-l loader" style="margin: 3px"></div>
              <div class="float-l min-cart" v-else-if="!isLoading && cart.data != null && getTotalItem() > 0">
                <span class="num">{{cart.data ? getTotalItem() : 0}}</span>
              </div>
                    {{$t('button_checkout')}}
                <div class="xs-float-right">
                    {{
                    $t('currency_display', {
                    currency: $const.CURRENCY,
                    amount: formatNumDisplay(cart.grand_total_after_apply_rm || 0)
                    })
                    }}
                </div>
            </button>
            <p class="text-center fw600 -ml-15 item-btn t13 mt-5" v-if="!checkMinCart()">
              {{
              $t('format_mincart', {
              currency: $const.CURRENCY,
              amount: getRequiredMinCart()
              })
              }}
            </p>
            <div v-if="isShowPaymentOnCart">
              <img :src="display_payment_cart" :alt="display_payment_cart">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../../assets/css/vueperslides.min.css'
import voucher from '../popup/ModalVoucher.vue'
import hutReward from '../popup/ModalHutReward.vue'
import ModalPopup from '../popup/ModalPizza'
import ModalUpdateCart from '../popup/ModalUpdateCart'
import * as action from '../../store/actions'
import { VueperSlides, VueperSlide } from 'vueperslides'
import { getExperiment } from '@pizza-hut/lib-experiments/lib'
import {
  mapGetters,
  mapActions
} from 'vuex'
import { time } from 'vue-analytics'

export default {
  props: ['byVoucher'],
  created () {
    const checkLayout = getExperiment('CVR', 'paymentOnCart')
    if (checkLayout !== this.getValueExperiment('paymentOnCart','showPayment')) {
      this.sendEventGA(this, 'CVR', 'paymentOnCart', 'notShowpayment', null, false)
      this.isShowPaymentOnCart = false
      return
    }
    this.isShowPaymentOnCart = true
    this.getConfigTenant()
  },
  mounted() {
    var vm = this
    vm.getAddOn()
    vm.getDonation()
    vm.getDataCutlery()

    this.$cart.init(this)
    this.$root.$on('cartUpdate', () => {
      vm.$cart.init(vm)
    })
    this.$root.$on('couponItemImplement', (data) => {
      if (data) {
        if (data.is_combo) {
          vm.$router.push({name: 'combo-detail', params: {nameseo: data.menu[0].uuid, ssid: 'coupon', coupon: data.coupon}})
        } else {
          vm.show(data.menu[0], '', data.coupon)
        }
      }
    })
    this.$root.$on('onRedirectToHome', () => {
      vm.$router.push({'name': 'home'})
    })
    this.$root.$on('cartAddItem', (data) => {
      vm.AddAddOnToCart(data)
    })

    this.$root.$on('showHideCart', (flag) => {
      vm.showHideCart(flag)
    })
    window.addEventListener('resize', function (e) {
      vm.resizeCart()
      vm.is_mobile = vm.isMobile()
    })
    vm.is_mobile = vm.isMobile()
    vm.resizeCart()
  },
  destroyed() {
    document.body.classList.remove('modal-open-cart')
  },
  data() {
    return {
      storeMinCart: 0,
      isShowBtnCheckOut: false,
      isCartOpen: false,
      is_mobile: false,
      addonsBottom: -15,
      slides: [],
      donation: null,
      isLoading: false,
      display_payment_cart: '',
      isShowPaymentOnCart: false,
      cutlery: null
    }
  },
  computed: {
    ...mapGetters({
      selectedProductByCart: 'selectedProductByCart',
      user: 'user'
    })
  },
  watch: {
    selectedCategory: function (newValue, oldValue) {

    },
    selectedSubCategory: function (newValue, oldValue) {

    },
  },
  methods: {
    ...mapActions({
      setSelectedCart: action.SET_SELECTED_CART
    }),
    getRedeemedRMVoucher (totalVoucherAmount) {
      return this.cart.grant_total < totalVoucherAmount ? this.cart.grant_total : totalVoucherAmount
    },
    isShowInCart() {
      const vm = this
      return vm.cart.total > 0 || (vm.cart.data && vm.cart.data.length > 0)
    },
    getRequiredMinCart() {
      let amount = 0
      let minCart = this.$disposition.getByKey(this, 'minCart', '')
      if (this.empty(minCart) || !minCart.hasOwnProperty('D') || minCart.D <= 0) {
        amount = 0
      } else {
        amount = minCart.D || 0
      }
      if (!isNaN(amount)) {
        amount = this.formatNumDisplay(amount)
      }
      return amount
    },
    getDataCutlery () {
      const vm = this
      const data = vm.getMenuRequest()
      vm.axios.getCutlery(data, function (response) {
        vm.cutlery = (response.data.data.items && response.data.data.items[0]) || null
      })
    },
    getAddOn () {
      let vm = this
      let data = vm.getMenuRequest()
      data.single_type = 1

      vm.axios.getAddOnByCategory(data, function (response) {
        let items = response.data.data.items;

        items.map((single)=>{
          let data = {}
          data = {
            "id": single.id,
            "item": single,
            "name": single.name,
            "imagelink": single.image.desktop_thumbnail ? single.image.desktop_thumbnail : 'https://static.pizzahut.jp/jp/menu/single/desktop_thumbnail_946f4682-8269-4529-9507-da07b3f24a06.jpg',
            "baseprice": single.min_price,
            "min_price": single.min_price,
            "category": single.category,
            "promotionprice": single.display_price,
            "uuid": single.uuid,
            "toppings": single.toppings,
            "category_id": single.category.uuid,
            "selling_start": single.selling_start,
            "type": single.type,
            "groups": single.groups,
          }
          vm.slides.push(data)
        })

      })
    },
    getConfigTenant() {
      let vm = this
      let params = {
        manual: 1
      }
      
      const paylah = vm.$session.get('paylahApp')
      if (paylah && paylah.uuid) {
        param.partner_app = 'dbsapp'
      }
      vm.axios.apiTenant.getConfigByClient(params, function (response) {
        vm.display_payment_cart = response.data.data.item && response.data.data.item.display_payment_cart ? response.data.data.item.display_payment_cart : ''
        
      })
    },
    getDonation () {
      let vm = this
      let data = vm.getMenuRequest()
      data.single_type = 1

      vm.axios.getDonation(data, function (response) {
        if(response.data.data.items.length > 0) {
          let single = response.data.data.items[0]
          vm.donation = {
            "id": single.id,
            "min_price": single.min_price,
            "category": single.category,
            "name": single.name,
            "imagelink": single.image.desktop_thumbnail,
            "baseprice": single.min_price,
            "promotionprice": single.display_price,
            "uuid": single.uuid,
            "toppings": single.toppings,
            "category_id": single.category.uuid,
            "selling_start": single.selling_start,
            "type": single.type,
            "groups": single.groups,
            "first_layers" : single.first_layers,
            "description": single.marketing_description
          }
        }
      })
    },
    enoughToCheckOut() {
      let minCart = this.$disposition.getByKey(this, 'minCart', '')
      let orderType = this.$disposition.getByKey(this, 'orderType', '')
      let cartTotal = this.cart.sub_total
      switch(orderType) {
        case this.$const.CARRYOUT:
          let c_min = minCart.C || 0
          return cartTotal >= c_min
          break;
        case this.$const.DELIVERY:
          let d_min = minCart.D || 0
          return cartTotal >= d_min
          break;
        default:
          let e_min = minCart.E || 0
          return cartTotal >= e_min

      }
    },
    checkMinCart() {
      const vm = this
      let minCart = this.$disposition.getByKey(this, 'minCart', '')
      let orderType = this.$disposition.getByKey(this, 'orderType', '')

      if (orderType == this.$const.CARRYOUT) {
        vm.storeMinCart = minCart.C
        return true
      }

      if (this.empty(minCart) || !minCart.hasOwnProperty('D') || minCart.D <= 0) {
        return true
      }

      minCart = minCart.D
      vm.storeMinCart = minCart
      let cartTotal = this.cart.total
      if (cartTotal >= minCart && cartTotal > 0) {
        return true
      }

      const isCouponByPassCart = vm.checkHasCouponByPassMinCart()
      if (isCouponByPassCart) {
        return true
      }

      return false
    },
    /**
     * Add item to cart
     * */
    ModifyQuantity(item, event) {
      event.stopPropagation()

      let vm = this
      if(item.is_donation == 1) {
        return false;
      }

      if(item.menu_type == vm.$const.FREE_ITEM_MENU_TYPE || item.menu_type == vm.$const.HUT_REWARD_MENU_TYPE) {
        return false;
      }

      if (item.coupon_code) {
        let coupon = null;
        let list = (vm.cart.coupon && vm.cart.coupon.data) ? vm.cart.coupon.data : []

        if (list) {
          for (let c in list) {
            if (list[c].code == item.coupon_code) {
              coupon = list[c]
              break;
            }
          }
        }

        if (coupon) {
          if (vm.lodash.includes(this.$const.COUPON_TYPES.FREE_GIFT, coupon.discount_type)) {
            return false
          } else if (vm.lodash.includes(this.$const.COUPON_TYPES.CIRCLE_DISCOUNT, coupon.discount_type) &&
            coupon.discount_quantity && !coupon.discount_value) {
            return false
          }
        }
      }

      this.$modal.show(ModalUpdateCart, {
          title: item.name,
          min: 1,
          max: 50,
          value: item.quantity,
          inputDisabled: true,
          update: function (data) {
            if (data && data > 0) {
              let quantity = Math.abs(data - item.quantity)
              let uuid = item.combo_uuid
              let variants = []
              let variantId = ''
              if (item.items.length > 0) {
                for (let i in item.items) {
                  if (item.items[i].layer_info && item.items[0].layer_info.first) {
                    variants.push(item.items[0].layer_info.first.uuid)
                    if (item.items.length == 1) {
                      variantId += item.items[0].layer_info.first.uuid
                      if (item.items[i].layer_info && item.items[0].layer_info.second) {
                        variantId += '-' + item.items[0].layer_info.second.uuid
                      }
                    }
                  }
                  uuid = uuid || item.items[i].product_uuid
                }
              }
              if (item.quantity > data) {
                let _item = vm._.cloneDeep(item)
                _item.category = _item.base_category || {}
                let pro = {
                  id: uuid,
                  item: _item,
                  price: item.item_price * quantity,
                  name: item.name,
                  variants: variants,
                  category: item.base_category,
                  price: item.item_price,
                  quantity: quantity
                }
                this.smartechRemoveItem(vm, pro)
                this.eventTrackingRemoveFromCart(this, pro)
              } else if (item.quantity < data) {
                let _item = vm._.cloneDeep(item)
                _item.category = _item.base_category || {}
                let pro = {
                  item: _item,
                  price: item.item_price * quantity,
                  id: uuid,
                  quantity: quantity,
                  variantId: variantId
                }
                this.smartechAddItem(vm, pro , vm.$router)
                this.eventTrackingUpdateQuantityFromCart(pro)
              }
              this.$cart.updateQuantity(this, {
                item_id: item.id,
                quantity: data
              })
            }
          }
        },
        {
          'class': 'modal-update-cart'
        },
        {
          'before-open': function () {
            document.body.classList.add('modal-open')
          },
          'before-close': function () {
            document.body.classList.remove('modal-open')
          }
        })

    },
    formatName(data, isHalf = false) {
      let text = '';
      if (isHalf) {
        text += "(" + data.layer_info.first.name + ") " + data.name;
      } else {
        if (data.items.length) {
          if (data.items[0].layer_info && data.items[0].layer_info.first) {
            text = data.items[0].layer_info.first.name;
          }

          text += " " + (data.name || '');
        }
      }


      return text;
    },
    formatSize(val) {
      if (val) {
        val = val.toLowerCase();
        if (val == "medium") {
          return "M size";
        } else if (val == "large") {
          return "L size";
        }
      }
    },
    AddAddOnToCart(data) {
      let item = {
        'group': {},
        'selling_start': data.selling_start
      }
      const products = []

      item.group['outlet_code'] = this.$disposition.getByKey(this,'outletCode','')
      item.group['tier'] = this.$cart.tier
      item.group['order_type'] = this.$cart.order_type
      item.group['order_time'] = this.getTimePickerDate(this)
      item.group['product_type'] = this.$const.CARD_ITEM_TYPE.COMBO
      item.group['combo_id'] = data.uuid
      item.group['quantity'] = 1
      item.group['category_uuid'] = this.$store.getters.category_uuid

      let pro = {
        items: [],
        item: data,
        id: data.uuid,
        name: data.name,
        price: data.price,
        context: 'upsell'
      }

      for (let i in data.groups) {
        let obj = data.groups[i].items[0]
        let product = {}

        if(Object.values(obj).length > 0){
          product.category_id = null
          product.combo_group_id = data.groups[i].uuid
          product.product_id = obj.uuid
          product.first_id = (obj.first_layers.length > 0) ? obj.first_layers[0].uuid : ''
          product.second_id = (obj.first_layers.length > 0
                                && obj.first_layers[0].second_layers
                                && obj.first_layers[0].second_layers.length > 0) ? obj.first_layers[0].second_layers[0].uuid : ''
          product.toppings = {}
          product.toppings.remove = []
          product.toppings.extra = []
          products.push(product)

          pro.items.push({
            item: obj,
            first: (obj.first_layers.length > 0) ? obj.first_layers[0] : {},
            second: (obj.first_layers.length > 0
              && obj.first_layers[0].second_layers
              && obj.first_layers[0].second_layers.length > 0) ? obj.first_layers[0].second_layers[0] : {}
          })
        }
      }
      // Process to make sure that combo_group_id of product is unique
      item.products = this.lodash.uniqBy(products, 'combo_group_id');
      // this.eventTrackingProductClickV2(this, data)
      let proClick = this._.cloneDeep(data)
      proClick.variant_uuid = ''
      this.evenTrackingProductClick(this, proClick, 'direct-product-selection-sidebar-basket-crossell')
      this.eventTrackingAddToCart(this, pro, 'main', this.$const.CARD_ITEM_TYPE.SINGLE, 'direct-product-selection-sidebar-basket-crossell')
      this.$cart.insert(this, item)
    },

    AddDonationToCart() {
      // console.log(this.$cart.get(this))
      let item = {
        "group": {},
        "products": []
      }

      item.group['outlet_code'] = this.$disposition.getByKey(this,'outletCode','')
      item.group['tier'] = this.$cart.tier
      item.group['order_type'] = this.$cart.order_type
      item.group['order_time'] = this.getTimePickerDate(this)
      item.group['product_type'] = this.$const.CARD_ITEM_TYPE.SINGLE
      item.group['combo_id'] = ''
      item.group['quantity'] = 1

      item.selling_start = this.donation.selling_start


      let products = {}
      products.category_id = this.donation.category_id
      products.combo_group_id = null
      products.product_id = this.donation.uuid
      products.first_id = (this.donation.first_layers.length > 0) ? this.donation.first_layers[0].uuid : ""//this.choosedFirst.uuid
      products.second_id = ""//this.choosedSecond.uuid
      products.toppings = {}
      products.toppings.remove = [] //this.$cart.getToppingById(this.removeYourTopping)
      products.toppings.extra = [] //this.$cart.getToppingById(this.addExtraTopping)
      item.products.push(products)

      console.log(this.donation)
      console.log('We will work on it later')
      console.log('Single -> add to cart from here')
      console.log('Combo -> link to combo page')
      console.log('Haft & haft -> Link to haft & haft page')

      // Single -> add to cart from here
      // Combo -> link to combo page
      // Haft & haft -> Link to haft & haft page
      //  item = {
      //   uuid: data.id,
      //   menu_id: data.id,
      //   menu_name: data.name,
      //   thumbnail: '',
      //   quantity: 1,
      //   price: data.promotionprice,
      //   plucode: 0,
      //   first_name: '',
      //   second_name: '',
      //   isCombo: 'N'
      // }
      let pro = {
        item: this.donation,
        id: this.donation.id,
        name: this.donation.name,
        min_price: this.donation.min_price,
        category: this.donation.category,
        price: this.donation.baseprice,
        first: (this.donation.first_layers.length > 0) ? this.donation.first_layers[0] : {},
        second: {}
      }
      let proClick = this._.cloneDeep(this.donation)
      proClick.variant_uuid = ''
      this.evenTrackingProductClick(this, proClick, 'direct-product-selection-sidebar-basket-crossell')
      // this.eventTrackingProductClickV2(this, pro)
      this.eventTrackingAddToCart(this, pro, 'main', this.$const.CARD_ITEM_TYPE.SINGLE, 'direct-product-selection-sidebar-basket-crossell')
      this.$cart.insert(this, item)
    },
    autoAddCouponToCart(data,coupon){
      let item = {
        'group': {},
        'selling_start': data.selling_start,
        'products': []
      }
      item.group.coupon_code = coupon
      item.group['outlet_code'] = this.getOutletCode(this)
      item.group['tier'] = this.$cart.tier
      item.group['order_type'] = this.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
      item.group['order_time'] = this.getTimePickerDate(this)
      item.group['product_type'] = data.product_type
      item.group['combo_id'] = null
      item.group['quantity'] = 1

      let product = {}
      let filterExtra = []
      product.category_id = this.$cart.category_id
      product.combo_group_id = ''
      product.product_id = data.uuid
      product.first_id = ''
      product.second_id = ''
      product.toppings = {}
      product.toppings.remove = {}
      item.products.push(product)
      this.$cart.insert(this, item)

      let pro = {
        item: data,
        id: data.uuid,
        name: data.name,
        price: data.totalPrice,
        first:  {},
        second: {}
      }
      let productclickUUid = product.product_id
      let variantUUid = ''
      if (!this.empty(product) && product.first_id != '') {
        variantUUid = product.first_id
      }
      if (!this.empty(product) && product.second_id != '') {
        variantUUid += '-' + product.second_id
      }
      this.evenTrackingProductClick(this, {uuid: productclickUUid, variant_uuid: variantUUid}, 'product-selection-from-variant-list')
      this.eventTrackingAddToCart(this, pro, 'main', this.$const.CARD_ITEM_TYPE.SINGLE)
    },

    /**
     * Remove item from cart
     * */
    removeCart(item) {
      this.$cart.remove(this, item.id)
      let variants = []
      let uuid = item.combo_uuid
      if (item.items.length > 0) {
        for (let i in item.items) {
          if (item.items[i].layer_info && item.items[0].layer_info.first) {
            variants.push(item.items[0].layer_info.first.uuid)
          }
          if (item.items[i].layer_info && item.items[0].layer_info.second) {
            variants.push(item.items[0].layer_info.second.uuid)
          }
          uuid = uuid || item.items[i].product_uuid
        }
      }
      let _item = this._.cloneDeep(item)
      _item.category = _item.base_category || {}
      let pro = {
        id: uuid,
        item: _item,
        name: item.name,
        price: item.total,
        variants: [variants.join('-')],
        category: item.base_category,
        price: item.item_price,
        quantity: item.quantity
      }
      // this.smartechRemoveItem(this, pro)
      this.eventTrackingRemoveFromCart(this, pro)
      // this.eventTrackingRemoveFromCartV2(this, pro)
    },
    /**
     * Update cart
     * */
    updateDonationCartData() {
      if(this.donation) {
        let item
        if (this.cart.data) {
          item = this.cart.data.find(it => it.is_donation == 1);
        }
        if (this.cart.is_use_donation && item == undefined) {
          this.AddDonationToCart()
        } else if (!this.cart.is_use_donation && item != undefined) {
          this.removeCart(item)
        }
      }
    },

    removeCoupon(code, isVoucher = false) {
      this.$cart.removeCoupon(this, {coupon_code: code}, isVoucher)
    },
    /**
     * Show modal voucher
     * */
    showModalVoucher() {
      if (!this.checkPosition(this)) {
        this.$router.push('/?isShowWarning=1')
        return false
      }
      this.$modal.show(voucher, {},
        {
          'class': 'modal-coupon'
        },
        {
          'before-open': function () {
            document.body.classList.add('modal-open')
          },
          'before-close': function () {
            document.body.classList.remove('modal-open')
          }
        })
    },
    showModalHutReward() {
      if (!this.checkPosition(this)) {
        this.$router.push('/?isShowWarning=1')
        return false
      }
      this.$modal.show(hutReward, {},
              {
                'class': 'modal-coupon'
              },
              {
                'before-open': function () {
                  document.body.classList.add('modal-open')
                },
                'before-close': function () {
                  document.body.classList.remove('modal-open')
                }
              })
    },
    /**
     * Add item to cart
     * */
    addItemOtherComponents(item) {
      this.$cart.insert(this, item)
    },
    /**
     * Show/Hide cart info
     * */
    showHideCart(flag) {
      this.isCartOpen = flag
      if (flag) {
        document.body.classList.add('modal-open-cart')
      } else {
        document.body.classList.remove('modal-open-cart')
      }
      this.resizeCart()
    },
    /**
     * Trigger resize window
     * */
    resizeCart() {
      if (document.documentElement.clientWidth > 768) {
        this.addonsBottom = 75
      } else {
        if (this.isCartOpen) {
          let container = this.$el.querySelector('.checkout-out')
          let nav = document.body.querySelector('#nav')
          this.addonsBottom = container.scrollHeight + nav.scrollHeight - 15
        } else {
          this.addonsBottom = -15
        }
      }
    },
    updateCartData () {
      const cart = this.$cart.get(this)
      cart['is_use_condiment'] = this.cart.is_use_condiment
      cart['is_use_cutlery'] = this.cart.is_use_cutlery
      cart['is_show_condiment'] = this.cart.is_show_condiment
      cart['is_show_cutlery'] = this.cart.is_show_cutlery
      this.$session.set('cart', cart)
      this.$cart.updateCartUuid(this, true)
    },
    checkHasCouponByPassMinCart() {
      let vm = this
      let willByPassMinCart = false

      // 1. If has by-pass-coupon ---> allow to checkout
      if (vm.cart && vm.cart.coupon) {
        if (vm.cart.coupon.by_pass_min_cart) {
          willByPassMinCart = true
        } else { // 2. Else (no by-pass-coupon) ---> compare original price (sub_total_without_tax) vs Store's mincart
          const coupons = vm.cart.coupon.data || []

          if (coupons) {
            vm._.forEach(coupons, function(item, i) {
              if (vm._.includes(vm.$const.COUPON_TYPES.DISCOUNT, item.discount_type)) {
                if (vm.cart.sub_total_without_tax >= vm.storeMinCart)
                willByPassMinCart = true
              }
            })
          }
        }
      }

      return willByPassMinCart
    },
    /**
     * Check out
     * */
    checkout: _.debounce(function() {
      let vm = this
      const isCouponByPassCart = vm.checkHasCouponByPassMinCart()

      if (this.cart.total <= 0 && !isCouponByPassCart) {
        this.$notify({
          type: 'warn',
          title: this.$t('please_add_more_food')
        })
        return
      } else if (this.enoughToCheckOut() || isCouponByPassCart) {
        document.body.classList.remove('modal-open-cart');
        if (this.isLoading) {
          return
        }
        setTimeout(function () {
          vm.isLoading = false
        }, 800)
        this.isLoading = true
        this.$cart.checkout(this, vm.cart.uuid)
        //this.$router.push({'name': 'checkout'})
      } else {
        // this.$notify({
        //   type: 'warn',
        //   title: this.$t('format_mincart', {currency: this.$const.CURRENCY, amount: this.getRequiredMinCart()})
        // })
        // return
        let minCart = this.$disposition.getByKey(this, 'minCart', '')
        vm.isCartOpen = false
        vm.$modal.show('dialog', {
          text: vm.$t('min_cart',{min_cart:minCart[this.$disposition.getByKey(this, 'orderType', '').charAt(0)]}),
          buttons: [
            {
              title: vm.$t('button_yes'),
              handler: () => {
                vm.$modal.hide('dialog')
              }
            },
          ]
        })

      }
    }, 500),
    getTotalItem() {
      let quantity = 0
      for (let i in this.cart.data) {
        quantity += this.cart.data[i] && this.cart.data[i].product_type !== 4 ? this.cart.data[i].quantity : 0
      }
      return quantity
    },
    editSingle(menu, isHalf = false) {
      if (menu.coupon_code) {
        return false
      }

      this.setSelectedCart({
        cartId: menu.id,
        productUuid: (menu.items && menu.items.length) ? menu.items[0].product_uuid : null,
        isHalf: isHalf,
        nameSeo: menu.friendly_seo_name || ''
      })
    },
    editCombo(menu) {
      if (menu.coupon_code) {
        return false
      }
      this.$router.push({name: 'combo-detail', params: {nameseo: menu.combo_uuid, ssid: menu.id}})
    },
    /**
     * Show modal popup
     * */
    show(item, itemId, coupon, isHalf = false) {
      if (!isHalf) {
        if(item.first_layers && item.first_layers.length === 0 && coupon){
          this.autoAddCouponToCart(item,coupon)
        } else {
          this.$modal.show(ModalPopup, {
            menu: item,
            coupon: coupon || '',
            scrollable: false,
            mfirst: {},
            msecond: {},
            itemId: itemId,
            extraCheese: []
          }, {
            class: 'modal-menu',
            transition: 'nice-modal-fade',
            overlayTransition: 'overlay-fade',
            clickToClose: false,
            name: 'close-modal-menu'
          }, {
            'before-open': this.beforeOpen,
            'before-close': this.beforeClose
          })
          let pro = {
            id: item.id,
            name: item.name,
            price: this.checkNum(item.min_price),
            brand: 'Google',
            cat: item.category_id,
            variant: '',
            position: 1
          }
        }
      } else {
        this.$modal.show(ModalPopupHalf, {
          menu: this.item,
          scrollable: false,
          mfirst: this.mode == 'list' && this.$route.params.slug == this.$const.MENU_PIZZA ? this.selectedVariant.first || {} : {},
          msecond: this.mode == 'list' && this.$route.params.slug == this.$const.MENU_PIZZA ? this.selectedVariant.second || {} : {},
          extraCheese: []
        }, {
          class: 'modal-menu',
          transition: 'nice-modal-fade',
          overlayTransition: 'overlay-fade',
          clickToClose: false,
          name: 'close-modal-menu'
        }, {
          'before-open': this.beforeOpen,
          'before-close': this.beforeClose
        })
      }

    },
    /**
     * Trigger before open modal popup
     * */
    beforeOpen(event) {
      document.body.classList.add('modal-open')
    },
    /**
     * Trigger before close modal popup
     * */
    beforeClose(event) {
      document.body.classList.remove('modal-open')
    },
  },
  components: { VueperSlides, VueperSlide }
}

</script>
<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .show-payment {
    width: 19%;
    height: 35px;
    margin-bottom: -6px;
    margin-top: 1%;
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
  }

  .show-payment img {
    margin-right: 5px;
    border: 2px solid #9e9e9e;
    border-radius: 5px;
    box-shadow: 0px 5px 5px #aaaaaa;
  }

  .carousel-control.left {
    top: 50px;
    margin-left: -3px !important;
  }

  .carousel-control.right {
    top: 50px;
    margin-right: -3px !important;
  }

  /*.vueperslides {*/
  /*  padding-left: 20px;*/
  /*  padding-right: 20px;*/
  /*  height: 80px;*/
  /*  width: calc(100% + 20px);*/
  /*  margin-left: -10px;*/
  /*  background-color: #fff;*/
  /*}*/

  .min-cart {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.2);
    padding: 0px 9px;
  }
  .hut-rewards-cart {
    margin-top: 10px;
    border: solid 1px #a4a4a4;
    border-radius: 10px;
    width: 100%;
    text-align: center;
    text-align: left;
    padding: 10px;
    background-color: #f5f5f5;
  }

  .hut-rewards-balance {
    font-size: 13px;
    font-weight: 700;
    border-top: 1px solid;
    margin-top: 10px
  }
  .hut-reward-text{
    border: solid 1px #a4a4a4;
    width: 100%;
    height: 35px;
    text-align: center;
    line-height: 35px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 700;
    background-color: #ffffff;
    cursor: pointer;
  }

  .donation-box {
      margin-top: 10px;
      border: solid 1px #a4a4a4;
      border-radius: 10px;
      width: 100%;
      text-align: center;
      text-align: left;
      padding: 10px;
  }

  /* .icon-checkbox-cart:before {
      content:"";
      display:inline-block;
      vertical-align:middle;
      width:30px;
      height:30px;
      margin-right:10px;
      position:relative;
      background-color:#fff;
      border:2px solid hsla(207,8%,51%,.5);
      -webkit-box-flex:0;
      -webkit-flex:0 0 auto;
      -ms-flex:0 0 auto;
      flex:0 0 auto;
      border-radius:5px
  }

  .checkbox:checked + .icon-checkbox-cart::after{
      background-image:url("data:image/svg+xml;charset=utf8,%3Csvg width='18' height='14' viewBox='0 0 18 14' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.56.415l-9.94 9.852-3.18-3.134c-.26-.256-.617-.414-1.01-.414C.64 6.72 0 7.35 0 8.133c0 .39.16.745.42 1l4.19 4.136c.257.256.615.414 1.01.414.394 0 .75-.158 1.01-.414L17.58 2.417c.258-.257.418-.61.418-1C18 .633 17.36 0 16.57 0c-.393 0-.75.16-1.01.415z' fill='%234D4D4D' fill-rule='evenodd'/%3E%3C/svg%3E");
      background-repeat:no-repeat;
      background-position:50%
  } */

  .icon-checkbox-cart {
    margin-right: 0px;
    margin-top: 5px;
  }
  .icon-checkbox-cart:before {
      border-radius: 0;
      width: 18px;
      height: 18px;
  }
  .checkbox:checked + .icon-checkbox-cart::after{
      content: "";
      width: 8px;
      height: 10px;
      position: absolute;
      left: 5px;
      top: 3px;
      background-color: #ffffff;
      border-radius: 0;
      border: solid #70a401;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(38deg);
      transform: rotate(38deg);
  }
  .cart-coupon-code-text {
    width: 210px;
    display: block;
    overflow: hidden;
    word-wrap: break-word;
  }
  .item-rm-voucher {
    border-bottom: 1px solid #eeeeee;
    flex-direction: column;
  }
  .item-rm-voucher-border-top {
    border-top: 1px solid #eeeeee;
  }
  .item-rm-voucher .per-rm-voucher {
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .action-quanlity-remove .cart-quantity {
    font-weight: 700;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/Cart.vue